import moment from "moment-timezone";
import Axios, { Response } from "../utils/Axios";
import { getRecoil } from "recoil-nexus";
import { authState, masterStoreState } from "../recoil/auth";

type Params =
  | "timer"
  | "sector"
  | "category"
  | "product"
  | "card"
  | "voucher"
  | "coupon"
  | "adver"
  | "concierge"
  | "storeChat"
  | "cs"
  | "cart"
  | "event"
  | "navigate"
  | "payment"
  | "order"
  | "morningCall"
  | "arrival"
  | "checkout"
  | "cancel"
  | "rating"
  | "lang"
  | "click"
  | "guide"
  | "error"
  | "interphone";

// click: {
//     path: 로그 발생지 (페이지),
//     params: 목적(이벤트 클릭, 상품 담기 등),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(sector_id, product_id, event_id...)
// }

// navigate: {
//     path: 로그 발생지 (페이지),
//     params: 발생 이벤트 (페이지 이동, 광고 이동 등),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(sector_id, product_id...)
// }

// event: {
//     path: 로그 발생지 (페이지),
//     params: 발생한 이벤트(채팅, 도착, 취소, 평가, ...),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(order_id, cs_id...),
// }

const LogController = {
  click: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response | undefined> => {
    try {
      if (!getRecoil(masterStoreState)) return;
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        action_name: "click",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  navigate: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response | undefined> => {
    try {
      if (!getRecoil(masterStoreState)) return;
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        action_name: "navigate",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  event: async (data: {
    path: string;
    params: string;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response | undefined> => {
    try {
      if (!getRecoil(masterStoreState)) return;
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        action_name: "event",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  error: async (data: {
    path: string;
    params: string;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response | undefined> => {
    try {
      if (!getRecoil(masterStoreState)) return;
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        action_name: "error",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  api: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response | undefined> => {
    try {
      if (!getRecoil(masterStoreState)) return;
      const oParams = {
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
        parent_store_id: getRecoil(masterStoreState)!.store_id,
        action_name: "api",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default LogController;
